import { FunctionComponent } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import FederatedMFE from 'common/components/FederatedMFE';
import { getProject, getProjectSource } from 'features/project/projectSlice';
import featureFlags from 'common/helpers/featureFlags';
import { injectReducerAsync } from '../../../app/reduxStore';

import styles from './SettingsPage.module.scss';

const SettingsPage: FunctionComponent = () => {
  const { navigation = [] } = useSelector(getProject);
  const { projectId } = useParams<{
    projectId: string;
  }>();
  const projectSource = useSelector(getProjectSource);

  const isCDEEnabled = featureFlags.isProjectInitiationFromCDEEnabled;
  const isUMEnabled = featureFlags.isUserManagementEnabled;
  const isUserInAAD = featureFlags.isUserInAADEnabled;

  return (
    <div>
      <FederatedMFE
        urlKey="REACT_APP_SETTINGS_MFE_URL"
        scope="remoteapp"
        reducerModule="./SettingsReducers"
        componentModule="./Settings"
        injectionReducerCb={injectReducerAsync}
        suspenseFallbackStyle={styles['settings-loader-wrapper']}
        props={{
          projectId,
          navigation,
          isCDEEnabled,
          isUMEnabled,
          projectSource,
          isUserInAAD,
        }}
      />
    </div>
  );
};

export default SettingsPage;
